import { i18n } from "../../translate/i18n";

export const title = i18n.t("titles.createdPlan.title");
export const subtitle = i18n.t("titles.createdPlan.subtitle");
